import { Button, Modal, Typography } from "antd";
import { ReactNode } from "react";

interface Props {
  open: boolean;
  /** The question, e.g. "Are you sure you want to delete the category?" */
  message: ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  isConfirming?: boolean;
  /** Defaults to "Yes"; pass something else only if the action is not a delete. */
  confirmText?: string;
}

/**
 * The delete confirmation used across the panel.
 *
 * Every screen had its own: some carried a title bar and a "Delete" button,
 * others none and a "Yes", and the copy sat left in one place and centred in
 * another. They are one component now so they cannot drift again — compact,
 * no title, the question centred, and Cancel / Yes centred beneath it.
 */
export const ConfirmDeleteModal = ({
  open,
  message,
  onCancel,
  onConfirm,
  isConfirming,
  confirmText = "Yes",
}: Props) => (
  <Modal
    open={open}
    centered
    maskClosable={false}
    width={420}
    title={null}
    onCancel={onCancel}
    footer={
      <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          type="primary"
          loading={isConfirming}
          onClick={onConfirm}
        >
          {confirmText}
        </Button>
      </div>
    }
  >
    <Typography.Paragraph style={{ textAlign: "center", marginBottom: 0 }}>
      {message}
    </Typography.Paragraph>
  </Modal>
);
